import { Directive, Input } from '@angular/core';

let nextUniqueId = 0;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-error',
  // `app-error` kept so the legacy theme styles it.
  host: {
    class: 'app-error',
    'aria-atomic': 'true',
    '[id]': 'id',
  },
})
export class FormFieldErrorDirective {
  @Input() id = `app-form-field-error-${nextUniqueId++}`;
}
